export default "__VITE_ASSET__CX$mGnMP__"